/* @ts-nocheck */
/* eslint-disable */
/* @noformat */
/* @formatter:off */
/**
* Generated by ng-openapi
* Generated Angular service for Feature controller
* Do not edit this file manually
*/
import { HttpClient, HttpContext, HttpContextToken, HttpEvent, HttpHeaders, HttpParams, HttpResponse } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { BASE_PATH_DEFAULT, CLIENT_CONTEXT_TOKEN_DEFAULT } from "../tokens";
import { HttpParamsBuilder } from "../utils/http-params-builder";
import { RequestOptions, GetFeatureByIdResponse, UpdateFeatureRequest, GetFeaturesResponse, CreateFeatureRequest, CreateFeatureResponse, GetFeatureSelectResponse } from "../models";

@Injectable({ providedIn: "root" })
export class FeatureService {
    private readonly httpClient: HttpClient = inject(HttpClient);
    private readonly basePath: string = inject(BASE_PATH_DEFAULT);
    private readonly clientContextToken: HttpContextToken<string> = CLIENT_CONTEXT_TOKEN_DEFAULT;

    private createContextWithClientId(existingContext?: HttpContext): HttpContext {
        const context = existingContext || new HttpContext();
        return context.set(this.clientContextToken, 'default');
    }

    getFeatureById(id: number, observe?: 'body', options?: RequestOptions<'json'>): Observable<GetFeatureByIdResponse>;
    getFeatureById(id: number, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<GetFeatureByIdResponse>>;
    getFeatureById(id: number, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<GetFeatureByIdResponse>>;
    getFeatureById(id: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/Feature/${id}`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.get(url, requestOptions);
    }

    updateFeature(id: number, updateFeatureRequest: UpdateFeatureRequest, observe?: 'body', options?: RequestOptions<'json'>): Observable<any>;
    updateFeature(id: number, updateFeatureRequest: UpdateFeatureRequest, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<any>>;
    updateFeature(id: number, updateFeatureRequest: UpdateFeatureRequest, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<any>>;
    updateFeature(id: number, updateFeatureRequest: UpdateFeatureRequest, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/Feature/${id}`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Set Content-Type for JSON requests if not already set
        if (!headers.has('Content-Type')) {
            headers = headers.set('Content-Type', 'application/json');
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.put(url, updateFeatureRequest, requestOptions);
    }

    deleteFeature(id: number, observe?: 'body', options?: RequestOptions<'json'>): Observable<any>;
    deleteFeature(id: number, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<any>>;
    deleteFeature(id: number, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<any>>;
    deleteFeature(id: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/Feature/${id}`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.delete(url, requestOptions);
    }

    getFeatures(searchTerm?: string | null, observe?: 'body', options?: RequestOptions<'json'>): Observable<GetFeaturesResponse>;
    getFeatures(searchTerm?: string | null, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<GetFeaturesResponse>>;
    getFeatures(searchTerm?: string | null, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<GetFeaturesResponse>>;
    getFeatures(searchTerm?: string | null, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/Feature`;

        let params = new HttpParams();
        if (searchTerm != null) {
            params = HttpParamsBuilder.addToHttpParams(params, searchTerm, 'searchTerm');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            params,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.get(url, requestOptions);
    }

    createFeature(createFeatureRequest: CreateFeatureRequest, observe?: 'body', options?: RequestOptions<'json'>): Observable<CreateFeatureResponse>;
    createFeature(createFeatureRequest: CreateFeatureRequest, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<CreateFeatureResponse>>;
    createFeature(createFeatureRequest: CreateFeatureRequest, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<CreateFeatureResponse>>;
    createFeature(createFeatureRequest: CreateFeatureRequest, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/Feature`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Set Content-Type for JSON requests if not already set
        if (!headers.has('Content-Type')) {
            headers = headers.set('Content-Type', 'application/json');
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.post(url, createFeatureRequest, requestOptions);
    }

    getFeatureSelect(observe?: 'body', options?: RequestOptions<'json'>): Observable<GetFeatureSelectResponse>;
    getFeatureSelect(observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<GetFeatureSelectResponse>>;
    getFeatureSelect(observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<GetFeatureSelectResponse>>;
    getFeatureSelect(observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/Feature/Select`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.get(url, requestOptions);
    }
}
